export default [
  {
    path: "/agenda-minutes",
    component: () => import("../layout/PageLayoutWithoutContainer.vue"),
    children: [
      {
        path: "verification",
        name: "Subscription",
        component: () =>
          import("@/views/AgendaAndMinutes/SubscriptionVerification.vue")
      },
      {
        path: "unsubscribe",
        name: "Unsubscribe",
        component: () =>
          import("@/views/AgendaAndMinutes/UnsubscribeVerification.vue")
      },
      {
        path: "create",
        name: "Create",
        component: () => import("@/views/AgendaAndMinutes/Create.vue")
      }
    ]
  }
];
